// eslint-disable-next-line import/prefer-default-export
export const getOvernightCampReviewAndSubmitSelector = ({
  yusaOvernightCampReviewAndSubmitData: { getReviewSubmit }
}) => getReviewSubmit;

export const postOvernightCampReviewAndSubmitSelector = ({
  yusaOvernightCampReviewAndSubmitData: { postReviewSubmit }
}) => postReviewSubmit;

export const getOvernightCampReopenSelector = ({
  yusaOvernightCampReviewAndSubmitData: { getReopenReport }
}) => getReopenReport;
